import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  component: {
    "& .MuiPaper-root": {
      maxWidth: "300px",
      [theme.breakpoints.up("sm")]: {
        maxWidth: "400px"
      }
    }
  },
  content: {
    padding: "16px 24px"
  },
  title: {
    borderBottom: "1px solid #ccc"
  },
  titleCaption: {
    fontFamily: "SuisseIntlMedium"
  },
  titleCaption2: {
    color: theme.palette.text.secondary,
    marginTop: "12px",
    maxWidth: "252px",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "352px"
    }
  },
  label: {
    color: theme.palette.text.hint,
    fontSize: "10px"
  },
  paragraph: {
    wordBreak: "break-all"
  },
  cancelButton: {
    fontSize: "16px",
    fontFamily: "SuisseIntlMedium",
    color: theme.palette.text.secondary
  },
  submitButton: {
    fontSize: "16px",
    fontFamily: "SuisseIntlMedium",
    color: theme.palette.secondary.dark
  }
}));
